import React from "react";
import "./Footer.css";
import {
  Zap,
  Instagram,
  Mail,
  MessageCircle,
} from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-professional">
      <div className="footer-container">
        {/* Column 1: Brand */}
        <div className="footer-column brand-column">
          <div className="footer-logo">
            <Zap size={24} className="logo-icon" />
            <span className="logo-text">Sharp Design</span>
          </div>
          <p className="brand-description">
            Elevando la identidad visual de la música. Diseño premium para
            artistas que buscan destacar en la era digital.
          </p>
        </div>

        {/* Column 2: Explore */}
        <div className="footer-column links-column">
          <h4 className="column-title">Explorar</h4>
          <ul className="footer-links-list">
            <li>
              <a href="#album">Album Design</a>
            </li>
            <li>
              <a href="#covers">Single Covers</a>
            </li>
            <li>
              <a href="#servicios">Servicios</a>
            </li>
            <li>
              <a href="#bio-section">Sobre mí</a>
            </li>
          </ul>
        </div>

        {/* Column 3: Contact */}
        <div className="footer-column contact-column">
          <h4 className="column-title">Contacto</h4>
          <div className="contact-item">
            <Mail size={16} />
            <a href="mailto:Designsharp92@gmail.com">Designsharp92@gmail.com</a>
          </div>
          <div className="contact-item">
            <MessageCircle size={16} />
            <a
              href="https://wa.me/584242603751"
              target="_blank"
              rel="noopener noreferrer"
            >
              WhatsApp Directo
            </a>
          </div>
        </div>

        {/* Column 4: Social */}
        <div className="footer-column social-column">
          <h4 className="column-title">Sígueme</h4>
          <div className="social-icons">
            <a
              href="https://www.instagram.com/sharp_dsgn/"
              className="social-icon-link"
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Instagram size={20} />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>© {currentYear} Sharp Design. Todos los derechos reservados.</p>
          <p className="made-by">Diseñado para el próximo nivel.</p>
        </div>
      </div>
    </footer>
  );
}
